import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "Title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "Body Collapsed"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_8 = {
  key: 1,
  class: "Body"
}
const _hoisted_9 = ["innerHTML"]

import { reactive, computed } from "vue";
import Proxy from "../api/proxy";

interface State {
  Ready: boolean;
  LongBody: string;
  IsCollapsed: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  title: { type: String, required: true },
  shortened: { type: String, required: true },
  id: { type: String, required: true },
  category: { type: String, required: true },
},
  setup(__props) {

const props = __props

const state = reactive<State>({
  Ready: true,
  LongBody: "",
  IsCollapsed: true,
});

const proxy = new Proxy();



const entryId = computed<string>(() => {
  return props.category + "Message" + props.id;
});

function clicked(): void {
  if (!state.Ready) {
    return;
  }

  if (state.IsCollapsed) {
    if (state.LongBody) {
      state.IsCollapsed = false;
    } else {
      fetchMessage()
        .then(() => {
          state.IsCollapsed = false;
        })
        .finally(() => {
          state.Ready = true;
        });
    }
  } else {
    state.IsCollapsed = true;
  }
}

async function fetchMessage(): Promise<void> {
  return new Promise((resolve, reject) => {
    proxy
      .getSpiritMessage(props.category, props.id)
      .then((r) => {
        setBodyHtml(r.lines);
        resolve();
      })
      .catch(() => reject());
  });
}

function setBodyHtml(lines: string[]): void {
  let html = "";
  lines.forEach((line) => {
    html += line + "<br/>";
  });
  state.LongBody = html;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _unref(entryId),
    class: _normalizeClass(["Message", [{ Collapsed: _unref(state).IsCollapsed }, props.category]]),
    onClick: clicked
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["Header", { Collapsed: _unref(state).IsCollapsed, Opened: !_unref(state).IsCollapsed }])
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1),
      (_unref(state).IsCollapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'chevron-down'],
              size: "1x"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'chevron-up'],
              size: "1x"
            })
          ]))
    ], 2),
    (_unref(state).IsCollapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              innerHTML: props.shortened
            }, null, 8, _hoisted_6),
            _hoisted_7
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              innerHTML: _unref(state).LongBody
            }, null, 8, _hoisted_9)
          ])
        ]))
  ], 10, _hoisted_1))
}
}

})